module.exports = __webpack_public_path__ + "fonts/656bb203-0436-41f9-8266-de61f5c29096.1566d397.woff";